import React from 'react'
import DayPicker from 'react-day-picker';
import SModal from 'components/sModal'
import moment from 'moment';
import { connect } from 'react-redux'
import './styles.css'

const toSmart = (date) => moment(date).format('YYYYMMDD')
const toDate = (smartDate) => moment(smartDate, 'YYYYMMDD').toDate()
const dateInFuture = (date) => moment(date).diff(moment()) > 0

const SDayPicker = ({closeModal, setUntilDate, untilDate}) => {

  const selectDay = (day) => {
    if(dateInFuture(day)) return
    setUntilDate(toSmart(day))
    closeModal()
  }

  return(
    <SModal.Main onClose={closeModal} noHead={true} closeOnOutsideClick={true} title='EDIT COIN' >
      <SModal.Body>
        <fb className="datePickerMain">
          <DayPicker
            disabledDays={date => dateInFuture(date)}
            onDayClick={(day) => selectDay(day) }
            selectedDays={toDate(untilDate)}
          />
        </fb>
      </SModal.Body>
    </SModal.Main>
  )
}

const actionsToProps = {
  setUntilDate: (smartDate)=>({ type: 'SET_UNTIL_DATE', payload: smartDate })
}

const mapStateToProps = (state: Store) => ({
  untilDate: state.ui.untilDate
})

export default connect(mapStateToProps, actionsToProps) (SDayPicker)



// WEBPACK FOOTER //
// ./src/modals/sDayPicker/index.js